<template>
  <div class="emoji-container">
    <button v-for="config in configs" :key="config.type" class="emoji-button"
            @click="() => onLike(config.type)"
    >
      {{ config.icon }}
    </button>
  </div>
</template>

<script>

import LikeService from '../../service/like.service'

export default {
  name: 'LikePicker',
  data() {
    return {
      configs: LikeService.getLikesConfig()
    }
  },
  methods: {
    onLike(type) {
      this.$emit('select', type)
    }
  }
}
</script>

<style scoped lang="scss">
.emoji-container {
  background-color: #f0f0f0;
  border: 1px solid #e4e4e4;
  border-radius: 50px;
  padding: 5px;
  display: flex;
  align-items: center;
}

$emojiHeight: 44px;
// some css is needed for windows display... (padding, line-height..)
.emoji-button {
  font-size: 1.2rem;
  width: $emojiHeight;
  height: $emojiHeight;
  border: 0;
  padding: 0;
  cursor: pointer;
  background-color: transparent;

  &:hover {
    font-size: 2rem;
    line-height: 2rem;
  }
}
</style>
